/** Typed parquet sources; catalog scope publishes explores, attachment scope does not. */
export var ExternalSourceType;
(function (ExternalSourceType) {
    ExternalSourceType["CSV"] = "csv";
    ExternalSourceType["GOOGLE_SHEETS"] = "google_sheets";
})(ExternalSourceType || (ExternalSourceType = {}));
export var ExternalSourceStatus;
(function (ExternalSourceStatus) {
    /** Uploaded and sniffed, awaiting the user's confirmation. */
    ExternalSourceStatus["STAGED"] = "staged";
    /** Ingest in progress (initial or refresh). */
    ExternalSourceStatus["SYNCING"] = "syncing";
    ExternalSourceStatus["READY"] = "ready";
    ExternalSourceStatus["ERROR"] = "error";
})(ExternalSourceStatus || (ExternalSourceStatus = {}));
/** Controls whether a source is published into the project's Explore catalog. */
export var ExternalSourceScope;
(function (ExternalSourceScope) {
    ExternalSourceScope["CATALOG"] = "catalog";
    ExternalSourceScope["ATTACHMENT"] = "attachment";
})(ExternalSourceScope || (ExternalSourceScope = {}));
export const getExternalSourceDisplayName = (source) => source.connection.type === ExternalSourceType.CSV
    ? source.connection.originalFilename
    : source.name;
export const parseGoogleSheetsSpreadsheetId = (url) => url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/)?.[1];
/** The tab a sheet URL points at (its `gid`), when the URL names one. */
export const parseGoogleSheetsTabId = (url) => {
    const gid = url.match(/[#&?]gid=(\d+)/)?.[1];
    return gid === undefined ? undefined : Number(gid);
};
export const MAX_EXTERNAL_SOURCE_FILE_BYTES = 100 * 1024 * 1024;
//# sourceMappingURL=externalSources.js.map